<!-- Shape -->
@if (style().shape === 'Polygon') {
    <svg:polygon [id]="mainShapeId()"
                 class="base"
                 [attr.points]="HEPTAGON"
                 [ngClass]="pieceClasses()"
                 stroke-linecap="round"/>
}
@if (style().shape === 'Star') {
    <svg:polygon [id]="mainShapeId()"
                 class="base"
                 [attr.points]="EIGHT_POINTED_STAR"
                 [ngClass]="pieceClasses()"
                 stroke-linecap="round"/>
}
@if (style().shape === 'Circle') {
    <svg:circle [id]="mainShapeId()"
                class="base"
                [attr.cx]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.cy]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.r]="(0.5 * MartianChessComponentUtils.SPACE_SIZE) - MartianChessComponentUtils.STROKE_WIDTH"
                [ngClass]="pieceClasses()"/>
}
<!-- Points -->
@if (style().points === 'Concentric Circles') {
    <svg:circle class="base no-fill mid-stroke"
                [attr.cx]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.cy]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.r]="MartianChessComponentUtils.getRadius(3)"/>
    <svg:circle class="base no-fill mid-stroke"
                [attr.cx]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.cy]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.r]="MartianChessComponentUtils.getRadius(2)"/>
    <svg:circle class="base no-fill mid-stroke"
                [attr.cx]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.cy]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                [attr.r]="MartianChessComponentUtils.getRadius(1)"/>
}
@if (style().points === 'Dots') {
    <svg:g>
        <svg:circle class="base mid-stroke"
                    [attr.cx]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.cy]="0.45 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.r]="(0.2 / 3) * MartianChessComponentUtils.SPACE_SIZE"/>
        <svg:circle class="base mid-stroke"
                    [attr.cx]="0.45 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.cy]="0.55 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.r]="(0.2 / 3) * MartianChessComponentUtils.SPACE_SIZE"/>
        <svg:circle class="base mid-stroke"
                    [attr.cx]="0.55 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.cy]="0.55 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.r]="(0.2 / 3) * MartianChessComponentUtils.SPACE_SIZE"/>
    </svg:g>
}
@if (style().points === 'Horizontal Points') {
    <svg:g [ngClass]="pieceClasses()">
        <svg:circle class="base-no-stroke"
                    [attr.cx]="(0.5 * MartianChessComponentUtils.SPACE_SIZE) - (3 * horizontalDotsRadius)"
                    [attr.cy]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.r]="1.5 * horizontalDotsRadius"/>
        <svg:circle class="base-no-stroke"
                    [attr.cx]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.cy]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.r]="1.5 * horizontalDotsRadius"/>
        <svg:circle class="base-no-stroke"
                    [attr.cx]="(0.5 * MartianChessComponentUtils.SPACE_SIZE) + (3 * horizontalDotsRadius)"
                    [attr.cy]="0.5 * MartianChessComponentUtils.SPACE_SIZE"
                    [attr.r]="1.5 * horizontalDotsRadius"/>
    </svg:g>
}
